export default [
    {
        key: 'home',
        label: {
            vi: 'Trang chủ',
            en: 'Home',
            fr: 'Accueil',
            es: 'Inicio',
            id: 'Beranda',
            ja: 'ホーム',
            zh: '首页',
            ko: '홈',
            hi: 'होम',
            ar: 'الرئيسية'
        },
        icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1',
        path: '/home',
        visible: {
            whenUserScreen: 'Dashboard'
        }
    },
    {
        key: 'omni',
        label: {
            vi: 'Sàn TMĐT',
            en: 'Sale Channel',
            fr: 'Marketplaces',
            es: 'Canales de venta',
            id: 'Saluran penjualan',
            ja: 'ECモール',
            zh: '电商平台',
            ko: '판매 채널',
            hi: 'विक्रय चैनल',
            ar: 'قنوات البيع'
        },
        icon: 'M3 7h18M3 12h18M3 17h18M7 3v18M12 3v18M17 3v18',
        visible: {
            whenSys: {
                use_Module_SaleChannel: 1
            }
        }
    },
    {
        key: 'social',
        label: {
            vi: 'Kênh xã hội',
            en: 'Social Channel',
            fr: 'Canaux sociaux',
            es: 'Canales sociales',
            id: 'Saluran sosial',
            ja: 'ソーシャル',
            zh: '社交渠道',
            ko: '소셜 채널',
            hi: 'सोशल चैनल',
            ar: 'القنوات الاجتماعية'
        },
        icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
        visible: {
            whenSys: {
                use_Module_SocialChannel: 1
            }
        }
    },
    {
        key: 'ar',
        label: {
            vi: 'Bán hàng',
            en: 'Sales',
            fr: 'Ventes',
            es: 'Ventas',
            id: 'Penjualan',
            ja: '販売',
            zh: '销售',
            ko: '판매',
            hi: 'बिक्री',
            ar: 'المبيعات'
        },
        icon: 'M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z',
        visible: {
            whenSys: {
                use_Module_AR: 1
            }
        }
    },
    {
        key: 'ic',
        label: {
            vi: 'Kho hàng',
            en: 'Warehouse',
            fr: 'Entrepôt',
            es: 'Almacén',
            id: 'Gudang',
            ja: '倉庫',
            zh: '仓库',
            ko: '창고',
            hi: 'गोदाम',
            ar: 'المستودع'
        },
        icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
        visible: {
            whenSys: {
                use_Module_IC: 1
            }
        }
    },
    {
        key: 'ap',
        label: {
            vi: 'Mua hàng',
            en: 'Purchase',
            fr: 'Achats',
            es: 'Compras',
            id: 'Pembelian',
            ja: '仕入',
            zh: '采购',
            ko: '구매',
            hi: 'खरीद',
            ar: 'المشتريات'
        },
        icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
        visible: {
            whenSys: {
                use_Module_AP: 1
            }
        }
    },
    {
        key: 'mf',
        label: {
            vi: 'Sản xuất',
            en: 'Manufacturing',
            fr: 'Production',
            es: 'Manufactura',
            id: 'Manufaktur',
            ja: '製造',
            zh: '制造',
            ko: '제조',
            hi: 'निर्माण',
            ar: 'التصنيع'
        },
        icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065zM15 12a3 3 0 11-6 0 3 3 0 016 0z',
        visible: {
            whenSys: {
                use_Module_MF: 1
            }
        }
    },
    {
        key: 'ca',
        label: [
            {
                whenSys: { use_Module_GL: 1 },
                value: {
                    vi: 'Sổ quỹ',
                    en: 'Cash',
                    fr: 'Trésorerie',
                    es: 'Caja',
                    id: 'Kas',
                    ja: '現金',
                    zh: '现金',
                    ko: '현금',
                    hi: 'नकद',
                    ar: 'النقدية'
                }
            },
            {
                value: {
                    vi: 'Tiền',
                    en: 'Cash',
                    fr: 'Trésorerie',
                    es: 'Efectivo',
                    id: 'Kas',
                    ja: '現金',
                    zh: '现金',
                    ko: '현금',
                    hi: 'नकद',
                    ar: 'النقدية'
                }
            }
        ],
        icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z',
        visible: {
            whenSys: {
                use_Module_CA: 1
            }
        }
    },
    {
        key: 'exp',
        label: {
            vi: 'Chi tiêu',
            en: 'Spending',
            fr: 'Dépenses',
            es: 'Gastos',
            id: 'Pengeluaran',
            ja: '支出',
            zh: '支出',
            ko: '지출',
            hi: 'खर्च',
            ar: 'الإنفاق'
        },
        icon: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
        visible: {
            whenSys: {
                use_Module_EXP: 1
            }
        }
    },
    {
        // Gói Kế toán (không có AR): tab Phải thu — Bán hàng, Phải thu khác, Khách hàng, hoá đơn bán ra.
        key: 'exr',
        label: {
            vi: 'Phải thu',
            en: 'Receivables',
            fr: 'Clients',
            es: 'Por cobrar',
            id: 'Piutang',
            ja: '売掛',
            zh: '应收',
            ko: '미수',
            hi: 'प्राप्य',
            ar: 'المدينون'
        },
        icon: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
        visible: {
            whenSys: {
                use_Module_EXR: 1,
                use_Module_AR: { type: '!=', value: 1 }
            }
        }
    },
    {
        key: 'fa',
        label: {
            vi: 'Tài sản',
            en: 'Assets',
            fr: 'Actifs',
            es: 'Activos',
            id: 'Aset',
            ja: '資産',
            zh: '资产',
            ko: '자산',
            hi: 'संपत्ति',
            ar: 'الأصول'
        },
        icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
        visible: {
            whenSys: {
                use_Module_FA: 1
            }
        }
    },
    {
        key: 'costing',
        label: {
            vi: 'Giá thành',
            en: 'Costing',
            fr: 'Calcul des coûts',
            es: 'Costeo',
            id: 'Perhitungan biaya',
            ja: '原価計算',
            zh: '成本计算',
            ko: '원가 계산',
            hi: 'लागत गणना',
            ar: 'التكلفة'
        },
        icon: 'M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z',
        visible: {
            whenSys: {
                use_Module_PNL: 1
            }
        }
    },
    {
        key: 'gl',
        label: {
            vi: 'Kế toán',
            en: 'Accounting',
            fr: 'Comptabilité',
            es: 'Contabilidad',
            id: 'Akuntansi',
            ja: '会計',
            zh: '会计',
            ko: '회계',
            hi: 'लेखांकन',
            ar: 'المحاسبة'
        },
        icon: 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z',
        visible: {
            whenSys: {
                use_Module_GL: 1
            }
        }
    },
    {
        key: 'tax',
        label: {
            vi: 'Thuế',
            en: 'Tax',
            fr: 'Taxe',
            es: 'Impuesto',
            id: 'Pajak',
            ja: '税金',
            zh: '税务',
            ko: '세금',
            hi: 'कर',
            ar: 'الضريبة'
        },
        icon: 'M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z',
        visible: {
            // Module Thuế ĐỘC LẬP với module Kế toán. Trước đây khoá nhầm theo
            // `use_Module_GL` (chép từ mục Kế toán ngay trên) nên hộ kinh doanh và
            // doanh nghiệp nhỏ không bật kế toán KHÔNG BAO GIỜ thấy tab Thuế — toàn bộ
            // cấu hình, hoá đơn, sổ sách và tờ khai đều không vào được từ giao diện.
            whenSys: {
                use_Module_Tax: 1
            }
        }
    },
    {
        key: 'hr',
        label: {
            vi: 'Nhân sự',
            en: 'HR',
            fr: 'RH',
            es: 'RRHH',
            id: 'SDM',
            ja: '人事',
            zh: '人事',
            ko: '인사',
            hi: 'मानव संसाधन',
            ar: 'الموارد البشرية'
        },
        icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z',
        visible: {
            whenSys: {
                use_Module_HR: 1
            }
        }
    },
    {
        key: 'pm',
        label: {
            vi: 'Dự án',
            en: 'Projects',
            fr: 'Projets',
            es: 'Proyectos',
            id: 'Proyek',
            ja: 'プロジェクト',
            zh: '项目',
            ko: '프로젝트',
            hi: 'परियोजना',
            ar: 'المشاريع'
        },
        icon: 'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z',
        visible: {
            whenSys: {
                use_Module_PM: 1
            }
        }
    },
    {
        key: 'report',
        label: {
            vi: 'Báo cáo',
            en: 'Reports',
            fr: 'Rapports',
            es: 'Informes',
            id: 'Laporan',
            ja: 'レポート',
            zh: '报告',
            ko: '보고서',
            hi: 'रिपोर्ट',
            ar: 'التقارير'
        },
        icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
        visible: {}
    },
    {
        // Module CONNECT — Theo dõi kết nối với providers (monitoring, đối soát).
        // Khác với group "Kết Nối" trong module Settings (đó là CẤU HÌNH provider).
        // Module này là OPERATIONS: events/queues/fulfillments tracking + reconcile flows.
        key: 'connect',
        label: {
            vi: 'Kết nối',
            en: 'Connect',
            fr: 'Connecter',
            es: 'Conectar',
            id: 'Hubungkan',
            ja: '連携',
            zh: '连接',
            ko: '연결',
            hi: 'कनेक्ट',
            ar: 'الاتصال'
        },
        icon: 'M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1',
        visible: {
            // Hiện khi có ít nhất 1 module integration enable (theo dõi connection events
            // chỉ make sense khi user đã setup channel).
            when: {
                gr_sale:      { whenSys: { use_Module_SaleChannel: 1 } },
                gr_social:    { whenSys: { use_Module_SocialChannel: 1 } },
                gr_advertise: { whenSys: { use_Module_AdvertiseChannel: 1 } },
                gr_message:   { whenSys: { use_Module_MessageChannel: 1 } },
                gr_review:    { whenSys: { use_Module_ReviewChannel: 1 } },
                gr_affiliate: { whenSys: { use_Module_AffiliateChannel: 1 } },
                gr_carrier:   { whenSys: { use_Module_CarrierChannel: 1 } },
                gr_food:      { whenSys: { use_Module_FoodChannel: 1 } }
            },
            whenType: 'OR'
        }
    },
    {
        key: 'setting',
        label: {
            vi: 'Cài đặt',
            en: 'Settings',
            fr: 'Paramètres',
            es: 'Configuración',
            id: 'Pengaturan',
            ja: '設定',
            zh: '设置',
            ko: '설정',
            hi: 'सेटिंग',
            ar: 'الإعدادات'
        },
        icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4',
        visible: {}
    }
];
